import "./article_transportpage.css";

export const transportPage = (obj) => {
    const padding = (() => {
        switch (obj.bodyTextJustify) {
            case "start":
                return " pl-md-0";
            case "end":
                return " pr-md-0";
            default:
                return "";
        }
    })();

    return `
        <div class="transport transport__main ${obj.pageType}">
            <div class="row m-0">
                <div class="container p-md-0 transport__header__container">
                    <div class="transport__header">
                        <h1 class="article__header">${obj.title}</h1>
                        ${obj.parsedIntro.length > 2
            ? `<div class="article__intro">${obj.parsedIntro}</div>`
            : ""
        }
                    </div>
                    ${obj.hasImage ? `${obj.mainImage}` : ""}
                </div>
            </div>
            <div class="row m-0 transport__content__text">
                <div class="container justify-content-${obj.bodyTextJustify + padding
        } d-flex transport__content">
                    <div class="col-md-8${padding}">
                        ${obj.bodyText}
                    </div>
                </div>
            </div>    
            <div class="container pl-md-0 pr-md-0 transport__content">
                ${obj.content}
            </div>
        </div>
    `;
};
export const transportPageImage = (obj) => {
    return `
        <div class="article__introimage__container p-0 col-md-4">
            <img src="" alt="" class="article__introimage" id="${obj.id}" >
        </div>
    `;
};
